import * as React from 'react';

interface DotProps {
  cx?: number;
  cy?: number;
  color: string;
}

const Dot: React.FC<DotProps> = ({ cx, cy, color }) => {
  if (cx == null || cy == null || isNaN(cx) || isNaN(cy)) {
    return null;
  }

  return (
    <svg width={20} height={20} x={cx - 10} y={cy - 10} viewBox="0 0 640 640" data-testid="dot-svg">
      <defs>
        <path id="amdwKlApR" d="M120 320c0-110.38 89.62-200 200-200s200 89.62 200 200c0 110.39-89.62 200-200 200s-200-89.61-200-200z" />
      </defs>
      <use fill={color} xlinkHref="#amdwKlApR" />
      <use fillOpacity="0" stroke="#fff" strokeWidth="120" xlinkHref="#amdwKlApR" />
    </svg>
  );
};

export default Dot;
